import get from 'lodash/get';
import set from 'lodash/set';
import { mhecommSessionStorage, mhecommLocalStorage } from '../local-storage';

const ONE_HOUR = 60;

export const persistState = (storedState: any) => {
    const newState: any = {};

    if(storedState?.shopCartState?.getGuestCartTokenMagento){
        newState.shopCartState = newState.shopCartState || {};
        newState.shopCartState.getGuestCartTokenMagento = storedState?.shopCartState?.getGuestCartTokenMagento;
    }

    return newState;
}

class ShareableSessionStore {
    /*
        Note:
        1. any change to store value will always be in sync with local storage
        2. session store will sync itself only once when Redux store calls `preloadedState`
        3. Local storage values are mutable (ref to point 1.)
    */
    
    /*
        keysToSync = {
            [key] : {
                path as string
                expiryTime as number(in Minutes)
            },

            ---or---
            
            [key]: path as string
        }

        [key] => identifier for values in localStore
        path => is the path as defined in sessionStore
        expiryTime => after how much time you want the value to deleted from localStore
     */
    keysToSync = {
        guestCartToken: {
            path: "shopCartState.getGuestCartTokenMagento",
            expiryTime: ONE_HOUR * 2.5
        },
    };

    private getValue(key){
        return typeof this.keysToSync[key] === "object" ? this.keysToSync[key] : {path: this.keysToSync[key], expiryTime: null};
    }
    
    sync() { // sync session store with localstorage
        const state = mhecommSessionStorage.getState();
        Object.keys(this.keysToSync).forEach(key => {
            const {path, expiryTime} = this.getValue(key);
            const value = get(state, path);
            if(value){
                mhecommLocalStorage.set(key, value, expiryTime);
            }else{
                mhecommLocalStorage.remove(key);
            }
        });
    }

    load(){ // load localstorage values into sessionstore
        const state = mhecommSessionStorage.getState() || {};
        Object.keys(this.keysToSync).forEach(key => {
            const {path} = this.getValue(key);
            const value = mhecommLocalStorage.get(key);
            value && set(state, path, value);
        });
        mhecommSessionStorage.saveState(state);
    }

}

export const shareableSessionStore = new ShareableSessionStore();